import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';

const ModalInput = (props) => {
    let [val, setVal] = useState(props.value);

    useEffect(() => {
        setVal(props.value);
    }, [props.value])
    return (
        <Dialog header="Въвеждане на стойност" visible={props.display} style={{ width: '50vw' }} footer="" onHide={() => props.closeFunc()}>
            <p>
                <label>{props.title}</label><input className="form-control" type={props.dataType} value={val} onChange={(e) => setVal(e.target.value)} />
            </p>
            <button className="btn btn-primary" onClick={() => props.saveFunc(val)}>Запис</button>
        </Dialog>

    );
}


export default ModalInput;

